import React from "react";
import styled from "@emotion/styled";
const Header = (props) => {
  const Container = styled.div`
    // background-color: blue;
    display: flex;
    flex-direction: row;
    align-items: center;
    // justify-content: space-between;
    min-width: 1200px;
    color: white;
    position: relative;
    z-index: 15;

    @media (max-width: 1100px) {
      min-width: 0;
      flex-direction: column;
    }
  `;

  const Large = styled.div`
    font-size: 3em;
    margin-right: 30px;
    // height: 56px;
  `;

  const SmallContainer = styled.div`
    width: 75%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    @media (max-width: 1100px) {
      min-width: 0;
      flex-direction: column;
    }
  `;
  const Small = styled.a`
    margin-right: 5%;
    height: auto;
    font-size: 1.4em;
    cursor: pointer;
    text-decoration: none;
    color: white;
  `;

  return (
    <Container className="animated fadeIn delay-1s">
      <Large>KYLE WU</Large>
      <SmallContainer>
        <Small style={{ cursor: "default" }}>kewu@sfu.ca</Small>
        <Small href="http://www.github.com/kylewuu" target="_blank">
          github.com/kylewuu
        </Small>
        <Small href="http://www.linkedin.com/in/kylewuu" target="_blank">
          linkedin.com/in/kylewuu
        </Small>
        <Small style={{ cursor: "default" }}>Vancouver, BC</Small>
      </SmallContainer>
    </Container>
  );
};

export default Header;
